<template>
  <footer class="py-3 footer">
    <div class="container-fluid">
      <div class="row align-items-center justify-content-lg-between">
        <div class="nav nav-footer justify-content-center justify-content-lg-end">
          <div
            class="text-sm text-center copyright text-muted"
            :class="this.$store.state.isRTL ? 'text-lg-end' : 'text-lg-start'"
          >
            <template v-if="copyright">
              {{ copyright }}
            </template>
            <template v-else>
              © {{ new Date().getFullYear() }}, made with
              <i class="fa fa-heart"></i> by
              <a href="https://www.ccar.fun" class="font-weight-bold" target="_blank">CloudChain Co. Ltd.</a>
            </template>
            <template v-if="icpNumber">
              <br/>
              <a :href="icpUrl" target="_blank" style="color: #d3d3d3; text-decoration: none; font-size: 12px;">
                {{ icpNumber }}
              </a>
            </template>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { getICPInfo } from "@/api/main.js";

export default {
  name: "app-footer",
  data() {
    return {
      icpNumber: "",
      icpUrl: "https://beian.miit.gov.cn",
      copyright: "",
    };
  },
  mounted() {
    this.fetchICPInfo();
  },
  methods: {
    async fetchICPInfo() {
      try {
        const res = await getICPInfo();
        if (res.code === 0 && res.desc) {
          this.icpNumber = res.desc.icp_number || "";
          this.icpUrl = res.desc.icp_url || "https://beian.miit.gov.cn";
          this.copyright = res.desc.copyright || "";
        }
      } catch {
        // 后端不可用时默认不显示
      }
    },
  },
};
</script>
